<template>
    <div :class="['emoji-input', isFocus ? 'focus' : '']" :style="styleObject">
        <textarea
            style="outline: none;"
            spellcheck="false"
            :value="value"
            @input="inputVal"
            @focus="isFocus = true"
            @blur="isFocus = false"
            ref="textarea"
            :maxlength="maxlength"
            :rows="rows"
        ></textarea>
        <div class="emoji-input-ctrlbar">
            <img ref="chooseBtn" class="emoji-input-choose-btn" v-if="!active" src="./source/images/expression.png" alt="expression" />
            <img v-else ref="chooseBtn" class="emoji-input-choose-btn active" src="./source/images/expression_active.png" alt="expression_active" />
        </div>

        <div class="emoji-input-source-list" v-show="active" ref="emojiContainer">
            <i :title="item.label" :class="['emoji-icon', 'emoji-icon-' + item.icon]" v-for="(item, index) in emojiConfig" @click="addEmoji(`[${item.value}]`)" :key="index"></i>
        </div>
        <div class="emoji-input-text-count" v-if="showWordLimit">{{ value.length }}/{{ maxlength }}</div>
    </div>
</template>

<script>
import emojiConfig from './source/data/emojiConfig.js'
export default {
    model: {
        prop: 'value',
        event: 'update'
    },
    props: {
        width: {
            type: [String, Number],
            default: '100%'
        },
        maxlength: {
            type: Number
        },
        showWordLimit: {
            type: Boolean,
            default: false
        },
        value: {
            type: String,
            default: ''
        },
        rows: {
            type: Number,
            default: 3
        }
    },
    computed: {
        styleObject() {
            return {
                width: typeof this.width === 'number' ? this.width + 'px' : this.width
            }
        }
    },
    data() {
        return {
            text: '',
            active: false,
            emojiConfig: Object.freeze(emojiConfig),
            isFocus: false
        }
    },
    mounted() {
        document.addEventListener('click', this.listenBlur.bind(this))
    },
    beforeDestroy() {
        document.removeEventListener('click', this.listenBlur)
    },
    methods: {
        listenBlur(e) {
            if (e.target === this.$refs.chooseBtn || e.target === this.$refs.emojiContainer) {
                if (e.target === this.$refs.chooseBtn) {
                    this.toggleChooseBtn()
                } else {
                    this.active = true
                }
            } else {
                this.active = false
            }
        },
        toggleChooseBtn() {
            this.active = !this.active
            console.log(this.active)
        },
        setVal(val) {
            this.inputVal(val)
            this.active = false
        },
        inputVal(e) {
            if (e instanceof Event) {
                this.$emit('update', e.target.value)
            } else {
                this.$emit('update', e)
            }
        },
        addEmoji(val) {
            let textarea = this.$refs.textarea
            console.log('textarea', textarea)
            let pos = this.getCursortPostion(textarea)
            let str = this.value.substr(0, pos) + val + this.value.substr(pos)
            this.inputVal(str)
            this.setCarePosition(textarea, pos + val.length)
        },
        getCursortPostion(ctrl) {
            let caretPos = 0
            // IE
            if (document.selection) {
                ctrl.focus()
                let selection = document.selection.createRange()
                selection.moveStart('character', -ctrl.value.length)
                caretPos = selection.text.length
                // Firefox
            } else if (ctrl.selectionStart || ctrl.selectionStart === 0) {
                caretPos = ctrl.selectionStart
            }
            return caretPos
        },
        setCarePosition(ctrl, pos) {
            ctrl.focus()
            if (ctrl.createTextRange) {
                let range = ctrl.createTextRange()
                range.collapse(true)
                range.moveEnd('character', pos)
                range.moveStart('character', pos)
                range.selet()
            } else {
                setTimeout(() => {
                    ctrl.selectionStart = pos
                    ctrl.selectionEnd = pos
                }, 0)
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.emoji-input {
    position: relative;
    width: 100%;
    border-radius: 4px;
    border: 1px solid rgb(220, 223, 230);
    box-sizing: border-box;
    transition-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);
    transition-duration: 0.2s;
    transition-delay: 0s;
    padding-bottom: 42px;
    &.focus {
        border: 1px solid #ff9000;
    }
    textarea {
        border: none;
        border-radius: 4px;
        // border: 1px solid rgb(220, 223, 230);
        box-sizing: border-box;
        padding: 5px 30px 5px 10px;
        resize: none;
        width: 100%;
        display: block;
        color: #606266;
        line-height: 1.5;
    }
    &-choose-btn {
        width: 24px;
        position: absolute;
        left: 10px;
        bottom: 10px;
        cursor: pointer;
    }
    &-source-list {
        width: 522px;
        display: flex;
        flex-wrap: wrap;
        position: absolute;
        z-index: 1;
        background: #fff;
        padding: 5px;
        left: 0;
        bottom: -190px;
        border: 1px solid #dcdfe6;
        i {
            display: block;
            margin: 5px;
            cursor: pointer;
        }
    }
    &-text-count {
        position: absolute;
        color: #909399;
        bottom: 4px;
        right: 10px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/emoji-input/emoji-input.vue